import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Rocket, ArrowRight } from "./Icons";

const SubscriptionSuccess: React.FC = () => {
  const navigate = useNavigate();
  const { slug } = useParams<{ slug: string }>();

  return (
    <div className="min-h-[80vh] flex flex-col items-center justify-center p-6 text-center">
      <div className="relative mb-8">
        <div className="absolute inset-0 bg-indigo-500/20 blur-3xl rounded-full animate-pulse" />
        <div className="relative bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 p-8 rounded-3xl shadow-2xl">
          <div className="w-20 h-20 bg-indigo-100 dark:bg-indigo-900/50 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <Rocket
              className="text-indigo-600 dark:text-indigo-400"
              size={40}
            />
          </div>

          <div className="flex items-center justify-center gap-2 mb-4">
            <h1 className="text-3xl font-extrabold text-slate-900 dark:text-white tracking-tight">
              You're all set!
            </h1>
          </div>

          <p className="text-lg text-slate-600 dark:text-slate-400 max-w-md mx-auto mb-8 leading-relaxed">
            Congratulations! Your subscription has been successfully activated.
            You now have full access to all the powerful features of your new
            plan.
          </p>

          <button
            onClick={() => navigate(`/${slug}/dashboard`)}
            className="w-full sm:w-auto px-8 py-4 bg-indigo-600 text-white font-bold rounded-xl hover:bg-indigo-700 shadow-lg shadow-indigo-500/20 transition-all active:scale-95 flex items-center justify-center gap-2 group"
          >
            Go to Dashboard
            <ArrowRight
              className="group-hover:translate-x-1 transition-transform"
              size={20}
            />
          </button>
        </div>
      </div>

      <p className="text-slate-400 dark:text-slate-500 text-sm">
        A receipt has been sent to your email address.
      </p>
    </div>
  );
};

export default SubscriptionSuccess;
